var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pdfIcon_svg__Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".pdfIcon_svg__st0{fill:#11b24c}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdfIcon_svg__XMLID_26_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "pdfIcon_svg__st0",
    d: "M187.7 329h-11.4v51.3h11.4c5.6 0 10.1-1.9 13.4-5.7 3.3-3.8 5-8.7 5-14.6v-10.7c0-5.9-1.7-10.7-5-14.5-3.3-3.9-7.8-5.8-13.4-5.8z",
    id: "pdfIcon_svg__XMLID_156_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pdfIcon_svg__st0",
    d: "M365.6 285.9H40.3v133.9h276.3l49-133.9zm-221.7 71.3c-4.4 4-10.4 5.9-18.1 5.9h-15.1v26.5H99v-70h26.8c7.7 0 13.8 2 18.1 6 4.4 4 6.6 9.2 6.6 15.7 0 6.7-2.2 11.9-6.6 15.9zm73.8 2.8c0 8.8-2.8 15.9-8.3 21.4-5.6 5.5-12.8 8.3-21.7 8.3h-23.1v-70h23.1c8.9 0 16.1 2.8 21.7 8.3 5.6 5.5 8.3 12.7 8.3 21.4V360zm60.6-31h-33.1v21.4h28.2v9.4h-28.2v29.9h-11.7v-70h44.8v9.3z",
    id: "pdfIcon_svg__XMLID_56_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pdfIcon_svg__st0",
    d: "M125.8 329h-15.1v24.7h15.1c4.3 0 7.6-1.2 9.8-3.5 2.2-2.3 3.3-5.2 3.3-8.8s-1.1-6.5-3.3-8.9c-2.2-2.3-5.5-3.5-9.8-3.5z",
    id: "pdfIcon_svg__XMLID_55_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pdfIcon_svg__st0",
    d: "M352.9 6H107.4c-7.3 0-13.3 6-13.3 13.3v256.8h26.6V32.6h232.2v92.2h92.2v354.6H120.7v-49.8H94.1v63.1c0 7.3 6 13.3 13.3 13.3h351c7.3 0 13.3-6 13.3-13.3V124.8L352.9 6z",
    id: "pdfIcon_svg__XMLID_29_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pdfIcon_svg__st0",
    id: "pdfIcon_svg__XMLID_28_",
    d: "M156.2 171.4h253.4V191H156.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pdfIcon_svg__st0",
    id: "pdfIcon_svg__XMLID_27_",
    d: "M156.2 209.5h213.3v19.6H156.2z"
  }))));
}
export default __webpack_public_path__ + "01e3ec9882626ac2d96bfe1ffe26d474.svg";
export { SvgPdfIcon as ReactComponent };